import { useShopStore } from "@/stores/shop";
import type { Product } from "@/stores/shop_defs";
import api from "@virgodev/bazaar/functions/api";
import fastShuffle from "fast-shuffle";

const shuffle = fastShuffle(Math.random());

export async function loadRelated(object: Product): Promise<Product[]> {
  const shop = useShopStore();
  let related: Product[] = [];

  const collections = shop.collections
    .filter((c) => object.categories.includes(c.id))
    .map((c) => c.id);

  if (collections.length > 0) {
    related = shuffle(
      shop.products.filter((p) =>
        p.categories.some((c) => collections.includes(c)),
      ),
    ).slice(0, 6);
  } else if (object.complete_look) {
    related = object.complete_look;
  } else if (object.cl_refs) {
    related = object.cl_refs
      .map((pid: number) => {
        return shop.products.find((p) => p.id === pid);
      })
      .filter((a) => a) as Product[];
  } else if (object.slug) {
    let response = await api({ url: `products/${object.slug}/related/` });
    if (response.ok) {
      related = response.body.related;
    } else {
      related = [];
    }
  }

  return related;
}
